<template>
  <v-content>
    <v-row align="center" justify="center">
      <v-col sm="11" xs="11" md="11" lg="10" xl="10">
        <v-toolbar color="secondary">
          <v-toolbar-title>Agendamentos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="$router.push('/multisign')" class="mx-2" fab dark small color="darkGrey">
            <v-icon color="white" dark>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <c-lista-usuarios @editar="abrirPopUpDeEdicao($event)" @deletar="abrirPopUpDeExclusao($event)" :headers="headers" :itens="agendamentos" :carregando="carregarListaAgendamento"></c-lista-usuarios>
      </v-col>
    </v-row>
    <c-agendamento :agendamentoPassado="agendamentoEditado" @fecharDialog="dialogDeEdicao = false" :dialog="dialogDeEdicao"></c-agendamento>
    <c-dialog-excluir
      :loaderExcluir="loderExcluirAgendamento"
      :dialogModalExcluir="dialogDeExclusao"
      txtModal="Tem certeza que deseja excluir </br> este agendamento?"
      @fecharDialog="dialogDeExclusao = false"
      @apagarRevendedor="apagarAgendamento()"
    ></c-dialog-excluir>
  </v-content>
</template>

<script>
import ListaUsuarios from "../components/usuarios/ListaUsuarios";
import { headersPadrao } from "../mixins/HeadersMixin";
import { receber, apagar } from "../mixins/RequisicaoMixin";
import DialogExcluir from "../components/usuarios/DialogExcluir";
import Agendamento from "../components/assinaturas/Agendamento";
import { bus } from "../main";

export default {
  data() {
    return {
      agendamentos: [],
      loderExcluirAgendamento: false,
      carregarListaAgendamento: false,
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Data de início", value: "execucao" },
        { text: "Data do fim", value: "vencimento" },
        { text: "Organização / Grupo", value: "nomeDaOrgOuGrupo"},
        { text: "Status", value: "status"},
        { text: "Ação", value: "acao", align: "center", sortable: false }
      ],
      dialogDeExclusao: false,
      agendamentoEditado: {},
      dialogDeEdicao: false,
      indexDoAgendamento: -1
    };
  },
  components: {
    "c-lista-usuarios": ListaUsuarios,
    "c-dialog-excluir": DialogExcluir,
    "c-agendamento": Agendamento
  },
  methods: {
    buscarAgendamentos() {
      this.carregarListaAgendamento = true;
      this.agendamentos = [];
      const idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
      const url = `/api/v1/agendamentos?cliente=${idDoCliente}`;
      receber(url, headersPadrao())
        .then(resposta => {
          this.agendamentos = resposta;
        })
        .catch(erro => {
          if(erro.request.status == 404){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          } else this.$store.commit("erro", "Erro ao buscar agendamentos.")
        })
        .finally(() => {
          this.carregarListaAgendamento = false;
        })
    },
    abrirPopUpDeExclusao(agendamento){
        this.dialogDeExclusao = true;
        this.agendamentoEditado = agendamento;
    },
    apagarAgendamento(){
        this.loderExcluirAgendamento = true;
        const url = `/api/v1/agendamentos/${this.agendamentoEditado.id}`;
        apagar(url, headersPadrao())
        .then(() => {
            this.indexDoAgendamento = this.agendamentos.indexOf(this.agendamentoEditado);
            this.agendamentos.splice(this.indexDoAgendamento, 1);
            this.$store.commit("sucesso", "Agendamento excluído com sucesso");
            this.indexDoAgendamento = -1;
        })
        .catch(erro => {
          if(erro.request.status == 404){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao excluir o agendamento.")
        })
        .finally(() => {
          this.loderExcluirAgendamento = false;
          this.dialogDeExclusao = false;
        })
    },
    abrirPopUpDeEdicao(agendamento){
      this.indexDoAgendamento = this.agendamentos.indexOf(agendamento);
      var objetoParaEnvio = Object.assign({}, agendamento)
      delete objetoParaEnvio.status;
      delete objetoParaEnvio.nomeDaOrgOuGrupo;
      delete objetoParaEnvio.vencimento;
      delete objetoParaEnvio.cadastro;
      objetoParaEnvio.data = objetoParaEnvio.execucao;
      delete objetoParaEnvio.execucao;
      this.dialogDeEdicao = true;
      this.agendamentoEditado = objetoParaEnvio;
    }
  },
  created() {
    this.buscarAgendamentos();
    bus.$on("agendamentoEditado", () => {
      this.buscarAgendamentos();
      this.indexDoAgendamento = -1;
      this.dialogDeEdicao = false;
    })
  }
};
</script>

<style>
</style>